/* eslint-disable @typescript-eslint/no-use-before-define */

import {
  Input,
  Component,
  forwardRef,
  HostListener,
  ViewChild,
  ElementRef,
  OnInit,
  Output,
  EventEmitter,
} from "@angular/core";
import { EInputStyleType } from "../../../data-types/input-style.enum";

@Component({
  selector: "cowing-slider",
  templateUrl: "./cowing-slider.component.html",
  styleUrls: ["./cowing-slider.component.scss"],
})
export class CowingSliderComponent {
  @Output("valueChanged") clicked = new EventEmitter();
  @Input("value") value: number = 0;

  constructor() {}

  public onInputChange($event?: any) {
    this.value = $event.target.value;
    this.clicked.emit(this.value);
  }
}
